package com.neurobs.ccabserver.administrator.view

import com.neurobs.js.dom.ElementFactory._
import com.neurobs.js.dom.DOMViewElement._
import com.neurobs.js.dom.Grid._
import com.neurobs.js.view.Container
import org.scalajs.dom.raw.KeyboardEvent
import scalatags.JsDom.all._

class ExaminerChatView {
	var onSubmitMessage: (String) => Unit = { _ => Unit }

	def setExaminerList(list: Seq[String]): Unit = {
		examinerList.innerHTML = list.mkString("\n")
		val show = list.nonEmpty || (chatBox.value != "")
		mainDiv.style.display = if (show) "inline-block" else "none"
	}

	def addMessage(message: String, user: String): Unit = {
		val current = chatBox.value
		val temp = current + (if (current.nonEmpty) "\n" else "")
		chatBox.value = s"$temp$user: $message"
		chatBox.scrollTop = chatBox.scrollHeight
	}

	private val examinerList = textarea(rows := 1, cols := 30, readonly).render
	private val chatBox = textarea(rows := 5, cols := 30, readonly).render
	private val messageBox = textarea(rows := 2, cols := 30).render

	messageBox.onkeydown = (e: KeyboardEvent) => {
		if ((e.keyCode == 13) && (!e.shiftKey)) {
			e.preventDefault()
			val message = messageBox.value
			messageBox.value = ""
			onSubmitMessage(message)
		}
	}

	private val mainDiv = div(style := "display: none").render
	val container: Container = {
		val panel = new PanelView(title = "Examiners", showRefresh = false, fullWidth = false)
		panel.grid.addRow(examinerList)
		panel.grid.addRow(chatBox)
		panel.grid.addRow(messageBox)
		mainDiv.appendChild(panel.container)
		mainDiv
	}
}
